import netflixSound from '../netflix-sound.mp3';

let introAudio: HTMLAudioElement | null = null;

export const getIntroAudio = (): HTMLAudioElement => {
  if (!introAudio) {
    introAudio = new Audio(netflixSound);
    introAudio.preload = 'auto';
    introAudio.volume = 1;
    introAudio.load();
  }
  return introAudio;
};

/** Best-effort autoplay; returns true if sound is playing. */
export const playIntroSound = async (): Promise<boolean> => {
  const audio = getIntroAudio();

  const tryPlay = async (mutedFirst: boolean): Promise<boolean> => {
    try {
      if (mutedFirst) {
        audio.muted = true;
      }
      await audio.play();
      if (mutedFirst) {
        audio.muted = false;
        audio.volume = 1;
      }
      return true;
    } catch {
      audio.pause();
      audio.currentTime = 0;
      audio.muted = false;
      return false;
    }
  };

  if (await tryPlay(false)) return true;
  if (await tryPlay(true)) return true;

  return false;
};

export const preloadIntroSound = (): void => {
  getIntroAudio();
};
